export interface LabelWithParam {
  label: string;
  params?: any[]
}
